export default {
    url: '',
    template: '<courses-rooms-list rooms="vm.rooms"/>',
    resolve: {
        rooms (RoomResource) {
            return RoomResource.query().$promise;
        }
    },
    controller (rooms) {
        this.rooms = rooms;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/rooms/list/index.js